function FAQ() {
  return <div>No content</div>;
}

export default FAQ;
